import { render, staticRenderFns } from "./CaseDetailSidebar.vue?vue&type=template&id=556fa78e&scoped=true&"
import script from "./CaseDetailSidebar.vue?vue&type=script&lang=js&"
export * from "./CaseDetailSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556fa78e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VNavigationDrawer,VRow})
